import React, { useState, useEffect } from "react";
let toastTimeout;

const Toast = () => {
    const [message, setMessage] = useState("");
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        window.Toast = {
            show: (msg = "Действие недоступно") => {
                setMessage(msg);
                setVisible(true);
                clearTimeout(toastTimeout);
                toastTimeout = setTimeout(() => setVisible(false), 3000);
            }
        };

        return () => {
            clearTimeout(toastTimeout);
            delete window.Toast;
        };
    }, []);

    return (
        <div className={`toast ${visible ? "show" : ""}`}>
            {message}
        </div>
    );
};

export default Toast;